var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("mh-image360-overlay", {
        ref: "image360Overlay",
        attrs: {
          "image-path":
            _vm.img360BasePath +
            _vm.currentVariation.item.id +
            "/Lv2/img01.jpg",
        },
      }),
      _vm._v(" "),
      _vm._t(
        "default",
        [
          _c(
            "div",
            { staticClass: "single container-max page-content" },
            [
              _c(
                "div",
                { staticClass: "row position-relative" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "col-12 col-lg-6 pt-0 pt-lg-3 px-0 px-md-3",
                    },
                    [
                      _c("mh-variation-tags", {
                        attrs: {
                          "variation-properties":
                            _vm.currentVariation.variationProperties,
                        },
                      }),
                      _vm._v(" "),
                      _c("mh-item-image-carousel", {
                        attrs: {
                          "max-quantity": _vm.maxImageCount,
                          "image-url-accessor": "url",
                        },
                      }),
                      _vm._v(" "),
                      _c("mh-image360-button", {
                        attrs: {
                          icon: _vm.modeherzPath + "/images/product/360.svg",
                          "image-path":
                            _vm.img360BasePath +
                            _vm.currentVariation.item.id +
                            "/Lv2/img01.jpg",
                        },
                        on: { supported: _vm.set360Supported },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-lg-6 px-0 px-lg-3" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "stick-in-parent",
                            rawName: "v-stick-in-parent",
                          },
                        ],
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-between px-3 px-lg-0 align-self-center flex-wrap flex-md-nowrap flex-lg-wrap flex-xl-nowrap mb-xl-3 pt-xl-5",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mb-3 mt-3 mt-xl-0 mb-xl-0 px-3 px-lg-0 align-self-end order-2 order-md-1 order-lg-2 order-xl-1",
                              },
                              [
                                _c("mh-manufacturer-title", {
                                  attrs: {
                                    manufacturer:
                                      _vm.currentVariation.item.manufacturer,
                                    "category-id-name-map":
                                      _vm.mainCategoryIdNameMap,
                                    lang: _vm.lang,
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "h1",
                                  {
                                    staticClass: "h2 title font-weight-normal",
                                  },
                                  [
                                    _vm.productType
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "product-type-title",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.productType
                                                    ? _vm.productType
                                                    : ""
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("br"),
                                        ]
                                      : _vm._e(),
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(_vm.itemName1) +
                                        "\n                  "
                                    ),
                                  ],
                                  2
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "manufacturer-logo align-self-end order-1 order-md-2 order-lg-1 order-xl-2 mb-2 mb-md-4 mb-lg-2 mb-xl-2 ml-3",
                              },
                              [
                                _c("mh-manufacturer-image", {
                                  attrs: {
                                    manufacturer:
                                      _vm.currentVariation.item.manufacturer,
                                    "category-id-name-map":
                                      _vm.mainCategoryIdNameMap,
                                    lang: _vm.lang,
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm._t("item-usps"),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "bg-custom single-rightside p-4" },
                          [
                            _c("mh-variation-selection", {
                              attrs: {
                                "variation-id":
                                  _vm.currentVariation.variation.id,
                                "variation-properties":
                                  _vm.currentVariation.variationProperties,
                                "preload-image-limit":
                                  _vm.variationPreviewCount,
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _vm._t("tag-list"),
                                _vm._v(" "),
                                _vm._t("before-price"),
                                _vm._v(" "),
                                _c("mh-variation-price", {
                                  attrs: {
                                    variation: _vm.currentVariation,
                                    "minimum-absolute-value":
                                      _vm.crossPriceMinimumAbsoluteValue,
                                    "minimum-percentage-value":
                                      _vm.crossPriceMinimumPercentage,
                                    "has-free-shipping": _vm.isFreeShipping,
                                  },
                                }),
                                _vm._v(" "),
                                _vm._t("after-price"),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "w-100" },
                                  [_vm._t("before-add-to-basket")],
                                  2
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "row my-3" }, [
                                  _vm.currentVariation.item.itemType === "set"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "alert alert-info w-100",
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.singleItemSetInfo"
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-12 col-md-7 col-xl-6",
                                        },
                                        [
                                          _c("add-to-basket", {
                                            attrs: {
                                              "variation-id":
                                                _vm.currentVariation.variation
                                                  .id,
                                              "is-salable":
                                                !!_vm.currentVariation.filter &&
                                                _vm.currentVariation.filter
                                                  .isSalable,
                                              "has-children":
                                                !!_vm.currentVariation.filter &&
                                                _vm.currentVariation.filter
                                                  .hasActiveChildren,
                                              "interval-quantity":
                                                _vm.currentVariation.variation
                                                  .intervalOrderQuantity || 1,
                                              "minimum-quantity":
                                                _vm.currentVariation.variation
                                                  .minimumOrderQuantity,
                                              "maximum-quantity":
                                                !!_vm.currentVariation.variation
                                                  .maximumOrderQuantity &&
                                                _vm.currentVariation.variation
                                                  .maximumOrderQuantity > 0
                                                  ? _vm.currentVariation
                                                      .variation
                                                      .maximumOrderQuantity
                                                  : null,
                                              "order-properties":
                                                _vm.currentVariation.properties.filter(
                                                  function (prop) {
                                                    return prop.property
                                                      .isOderProperty
                                                  }
                                                ),
                                              "use-large-scale": false,
                                              "show-quantity": true,
                                              "item-url": _vm._f("itemURL")(
                                                _vm.currentVariation
                                              ),
                                              "is-variation-selected":
                                                _vm.isVariationSelected &&
                                                _vm.currentVariation.filter
                                                  .isSalable,
                                              "has-price": _vm._f(
                                                "hasItemDefaultPrice"
                                              )(_vm.currentVariation),
                                              "forbidden-country-codes":
                                                _vm.forbiddenCountryCodes,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                  _vm._v(" "),
                                  _vm.isWishListEnabled
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-md-none col-6 col-md-4 col-xl-6 mt-3 mt-md-0 pl-md-0 single-wishlist",
                                        },
                                        [
                                          _c("mh-single-share-button", {
                                            attrs: {
                                              variation: _vm.currentVariation,
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isWishListEnabled
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-6 col-md-5 col-xl-6 mt-3 mt-md-0 pl-md-0 single-wishlist",
                                        },
                                        [
                                          _c("mh-add-to-wish-list", {
                                            attrs: {
                                              "item-id":
                                                _vm.currentVariation.item.id,
                                              "variation-id":
                                                _vm.currentVariation.variation
                                                  .id,
                                            },
                                            on: {
                                              "item-added":
                                                _vm.onItemAddToWishList,
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                _vm._t("additional-content-after-vat"),
                                _vm._v(" "),
                                _c("hr", { staticClass: "d-md-none" }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-content-around usps mt-4 mb-0 mb-md-4 flex-wrap flex-xl-nowrap",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex-wrap justify-content-around",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "single_availability d-flex align-items-center mt-3 mr-4",
                                          },
                                          [
                                            _c(
                                              "i",
                                              {
                                                staticClass:
                                                  "fa far fa-clock mr-3 mr-lg-2",
                                                attrs: {
                                                  "aria-hidden": "true",
                                                },
                                              },
                                              [_vm._v(" ")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                class:
                                                  "availability d-inline-block availability_" +
                                                  _vm.currentVariation.variation
                                                    .availability.id,
                                              },
                                              [
                                                _c("span", [
                                                  _c(
                                                    "b",
                                                    { staticClass: "d-block" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$translate(
                                                            "modeherz::SingleItemPageClient.itemPageAvailability" +
                                                              _vm
                                                                .currentVariation
                                                                .variation
                                                                .availability
                                                                .id +
                                                              "Title"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "d-inline-block",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$translate(
                                                            "modeherz::SingleItemPageClient.itemPageAvailability" +
                                                              _vm
                                                                .currentVariation
                                                                .variation
                                                                .availability
                                                                .id +
                                                              "Description"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "sup",
                                                    {
                                                      staticClass:
                                                        "d-inline-block",
                                                    },
                                                    [_vm._v("7")]
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "single_delivery d-flex align-items-center mt-3 mr-4",
                                          },
                                          [
                                            _c(
                                              "i",
                                              {
                                                staticClass:
                                                  "fa far fa-shipping-fast mr-2",
                                                attrs: {
                                                  "aria-hidden": "true",
                                                },
                                              },
                                              [_vm._v(" ")]
                                            ),
                                            _vm._v(" "),
                                            !_vm.isFreeShipping
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "d-inline-block ml-2",
                                                  },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$translate(
                                                            "modeherz::SingleItemPageClient.itemPageFastDelivery"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$translate(
                                                            "modeherz::SingleItemPageClient.itemPagePremiumShipping"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              : _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "d-inline-block ml-2",
                                                  },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$translate(
                                                            "modeherz::SingleItemPageClient.itemPageFreeShipping"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$translate(
                                                            "modeherz::SingleItemPageClient.itemPageFreeShippingNote"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "single_return_policy d-flex align-items-center mt-3",
                                          },
                                          [
                                            _c(
                                              "i",
                                              {
                                                staticClass:
                                                  "fa far fa-undo-alt",
                                                attrs: {
                                                  "aria-hidden": "true",
                                                },
                                              },
                                              [_vm._v(" ")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "d-inline-block ml-3 ml-lg-2",
                                              },
                                              [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$translate(
                                                        "modeherz::SingleItemPageClient.itemPageRightOfReturn"
                                                      )
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _vm.isGermanShippingCountry
                                                  ? [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$translate(
                                                              "modeherz::SingleItemPageClient.itemPageRightOfReturnDetailDe"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  : _vm.isAustriaShippingCountry
                                                  ? [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$translate(
                                                              "modeherz::SingleItemPageClient.itemPageRightOfReturnDetailAt"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  : [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$translate(
                                                              "modeherz::SingleItemPageClient.itemPageRightOfReturnDetailOther"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ],
                                              ],
                                              2
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "w-100 mt-3 after-add-to-basket",
                                  },
                                  [
                                    _c(
                                      "client-only",
                                      [_vm._t("after-add-to-basket")],
                                      2
                                    ),
                                    _vm._v(" "),
                                    !!_vm.currentVariation.filter &&
                                    _vm.currentVariation.filter.isSalable
                                      ? _c("mh-order-now", {
                                          attrs: { lang: _vm.lang },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex align-items-end flex-wrap share-info mt-0",
                                  },
                                  [
                                    _c("mh-share-buttons", {
                                      attrs: {
                                        variation: _vm.currentVariation,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "mb-3 mb-md-0 mt-2 mt-md-0 text-center text-md-right variation-number order-1 order-md-2",
                                      },
                                      [
                                        _c("span", { staticClass: "small" }, [
                                          _c("span", [
                                            _vm._v(
                                              "modeherz ID: " +
                                                _vm._s(
                                                  _vm.currentVariation.variation
                                                    .id
                                                )
                                            ),
                                          ]),
                                          _vm._v(" | "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "modeherz::SingleItemPageClient.itemPageVariationNo"
                                                )
                                              ) +
                                                ":\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm.currentVariation.variation
                                                    .number
                                                )
                                            ),
                                          ]),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("mh-product-safety-link"),
                        _vm._v(" "),
                        _c("mh-top-merchant-badge", {
                          attrs: {
                            "variation-properties":
                              _vm.currentVariation.variationProperties,
                          },
                        }),
                        _vm._v(" "),
                        _vm._m(0),
                        _vm._v(" "),
                        _vm._t("additional-content-after-add-to-basket"),
                      ],
                      2
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-12 col-md-7 col-lg-6 px-4 single-description",
                    },
                    [
                      _c("div", { staticClass: "my-5" }, [
                        _c(
                          "div",
                          { staticClass: "tab-content overflow-hidden" },
                          [
                            _vm.isDescriptionTabActive
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "tab-pane active overflow-auto",
                                    attrs: {
                                      id:
                                        "details-" +
                                        _vm.currentVariation.variation.id,
                                      role: "tabpanel",
                                    },
                                  },
                                  [
                                    _c("div", {
                                      staticClass: "my-4",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.currentVariation.texts.description
                                        ),
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._t("add-detail-tabs-content"),
                          ],
                          2
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "col-12 col-md-5 col-lg-6 description-image",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "my-5" },
                        [
                          _vm.currentVariation.images.all[1]
                            ? _c("mh-item-image", {
                                attrs: {
                                  "img-url":
                                    _vm.currentVariation.images.all[1].url,
                                  alt: _vm.currentVariation.texts.name1,
                                  title: _vm.currentVariation.texts.name1,
                                  lazy: "",
                                  "img-class": "img-fluid",
                                },
                              })
                            : _vm.currentVariation.images.all[0]
                            ? _c("mh-item-image", {
                                attrs: {
                                  "img-url":
                                    _vm.currentVariation.images.all[0].url,
                                  alt: _vm.currentVariation.texts.name1,
                                  title: _vm.currentVariation.texts.name1,
                                  lazy: "",
                                  "img-class": "img-fluid",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("product-safety-modal", {
                    attrs: {
                      "variation-id": _vm.currentVariation.variation.id,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "lazy-hydrate",
                { attrs: { "when-visible": { rootMargin: "300px" } } },
                [
                  _c(
                    "div",
                    { staticClass: "item-list-wrapper" },
                    [_vm._t("item-list-container")],
                    2
                  ),
                ]
              ),
              _vm._v(" "),
              _vm._t("feedback-container"),
            ],
            2
          ),
        ],
        {
          getdatafield: _vm.getDataField,
          getfiltereddatafield: _vm.getFilteredDataField,
        }
      ),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex justify-content-center" }, [
      _c("div", { attrs: { "data-authorizedby-badge": "content" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }